import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  ServerSideErrorModal,
  IllustrationPillsCRO,
  SplitScreenPromo,
} from '@web/components';
import { Heading } from '@web/atoms';
import { CMSBlok } from '../../cms';
import { OnboardingContext } from '../OnboardingFlowContainer/context';
import { STATE_TO_STEP_REFERENCE } from '../OnboardingFlowContainer/constants';
import { CHECKOUT_STEPS } from '../CheckoutHeader/constants';
import { Header } from './Header';
import { Wrapper } from './styles.js';

export const PlanSelectionContainer = ({ children, body }) => {
  const { stateKey, showModal, setShowModal } = useContext(OnboardingContext);

  const components = {
    IllustrationPills: IllustrationPillsCRO,
    SplitScreenPromo: SplitScreenPromo,
    Heading: Heading,
  };

  const getComponent = name => {
    return components[name];
  };

  let EXTRA_STEPS_CONDITIONAL = CHECKOUT_STEPS;

  return (
    <Wrapper>
      <Header
        step={STATE_TO_STEP_REFERENCE[stateKey] || 0}
        checkoutSteps={EXTRA_STEPS_CONDITIONAL}
      />
      {children}
      {body.map(content => {
        //* Hard coded values have capitalized component names
        const Component = getComponent(content.component);
        return Component ? (
          <Component key={content.index} {...content} />
        ) : (
          <CMSBlok key={content._uid} content={content} />
        );
      })}
      <ServerSideErrorModal
        shown={showModal}
        headerText="Hmm, something's not right."
        errorMessage="We weren't able to complete your request, please refresh the page and try again."
        onCloseModal={() => setShowModal(false)}
      />
    </Wrapper>
  );
};

PlanSelectionContainer.displayName = 'PlanSelectionContainer';

PlanSelectionContainer.propTypes = {
  body: PropTypes.arrayOf(
    PropTypes.shape({
      _uid: PropTypes.string.isRequired,
    }),
  ).isRequired,
  children: PropTypes.object.isRequired,
};
